import { useEffect, useState } from 'react';
import { pca } from '..';
import Get from '../api/internal/Get';

interface DatabaseUser {
  employeeId: number;
  emailAddress: string;
  firstName: string;
  lastName: string;
  userDispatchId: number | null;
  phoneExtension: number | null;
}

const USER_CACHE_KEY = 'userDatabaseInfo';

export const useUser = (): DatabaseUser & {
  fullName: string;
  loading: Boolean;
} => {
  const [userDatabaseInfo, setUserDatabaseInfo] = useState<DatabaseUser | null>(
    null,
  );
  const [loading, setLoading] = useState(true);

  const accounts = pca.getAllAccounts();
  const { username: userEmail } = accounts[0] || {};

  useEffect(() => {
    const fetchDatabaseUser = async () => {
      try {
        setLoading(true);
        const cachedUser = sessionStorage.getItem(USER_CACHE_KEY);
        if (cachedUser) {
          setUserDatabaseInfo(JSON.parse(cachedUser));
          setLoading(false);
          return;
        }

        const response = await Get(`Employee/GetUserInfo`);
        if (response) {
          const userData = response.data;
          setUserDatabaseInfo(userData);
          sessionStorage.setItem(USER_CACHE_KEY, JSON.stringify(userData));
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDatabaseUser();
  }, []);

  return {
    fullName: userDatabaseInfo?.firstName + ' ' + userDatabaseInfo?.lastName,
    emailAddress: userDatabaseInfo?.emailAddress || userEmail,
    firstName: userDatabaseInfo?.firstName,
    lastName: userDatabaseInfo?.lastName,
    employeeId: userDatabaseInfo?.employeeId,
    userDispatchId: userDatabaseInfo?.userDispatchId,
    phoneExtension: userDatabaseInfo?.phoneExtension,
    loading,
  };
};
